module.exports = "/assets/data/7ca192a7489a83afc0011fbec6287227-IV9.data.json";